export function getPublicAssetUrl(path) {
  if (!path) return path;
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  if (path.startsWith(process.env.PUBLIC_URL || "/")) return path;
  const cleanPath = String(path).replace(/^\/+/, "");
  const publicUrl = process.env.PUBLIC_URL || "";
  return `${publicUrl}/${cleanPath}`;
}

export function getOptimizedImageUrl(path) {
  if (!path) return path;
  if (/^(https?:|data:|blob:)/i.test(path)) return path;

  const cleanPath = String(path).replace(/^\/+/, "");
  if (/\.webp(\?.*)?$/i.test(cleanPath)) {
    return getPublicAssetUrl(cleanPath);
  }
  if (!/\.(jpe?g|png)(\?.*)?$/i.test(cleanPath)) {
    return getPublicAssetUrl(cleanPath);
  }

  const optimizedPath = cleanPath.replace(/\.(jpe?g|png)(\?.*)?$/i, ".webp");
  return getPublicAssetUrl(`optimized/${optimizedPath}`);
}